export default {
  namespaced: true,

  state: {
    items: []
  },

  mutations: {
    retrieve(state) {
      window.Ajax.get('/vehicle-use-types')
        .then(response => {
          state.items = response.data;
        })
        .catch(err => {
          console.log(err);
        });
    }
  },

  getters: {
    all(state) {
      return state.items;
    }
  }
};
